import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Checkbox, FieldRow, FormFooter, Title } from '@xsolla/ui-core';
import { AlertDangerColorful } from '@xsolla/ui-icons';
import { ModalAlert } from '@xsolla/ui-modal';

import { ChangeKeySubtitle } from './style';
import { SignatureTypes } from './types';

type Props = {
  cancelClick: () => void;
  deleteClick: () => void;
  selectedSignature: SignatureTypes;
  fetching: boolean;
};

const ChangeKeyModal = ({
  cancelClick,
  deleteClick,
  selectedSignature,
  fetching
}: Props): JSX.Element => {
  const intl = useIntl();
  const [agreed, setAgreed] = useState<boolean>(false);

  const handleCheckbox = () => setAgreed((prevState) => !prevState);

  const renderFooter = () => {
    return (
      <FormFooter>
        <FieldRow justify="space-between" stretched>
          <Button look="tertiary" palette="muted" onClick={cancelClick}>
            {intl.formatMessage({ id: 'button.cancel' })}
          </Button>
          <Button
            palette="danger"
            onClick={deleteClick}
            fetching={fetching}
            disabled={!agreed}
            data-test-id="btn-submit-modal">
            {intl.formatMessage({ id: 'settings.signature.reset.submit' })}
          </Button>
        </FieldRow>
      </FormFooter>
    );
  };

  return (
    <ModalAlert footer={renderFooter()}>
      <React.Fragment key=".0">
        <AlertDangerColorful size={40} />
        <Title center indent="sm">
          {intl.formatMessage({ id: 'settings.signature.reset.title' })}
        </Title>
        <ChangeKeySubtitle>
          {intl.formatMessage({ id: `settings.signature.reset.${selectedSignature}.description` })}
        </ChangeKeySubtitle>
        <ChangeKeySubtitle>
          {intl.formatMessage({ id: 'settings.signature.reset.description' }, { br: () => <br /> })}
        </ChangeKeySubtitle>
        <Checkbox value={agreed.toString()} onChange={handleCheckbox}>
          {intl.formatMessage({ id: 'settings.signature.reset.checkbox' })}
        </Checkbox>
      </React.Fragment>
    </ModalAlert>
  );
};

export default ChangeKeyModal;
